<template>

  <!-- Icon Text Tile Block -->
  <page-block
    no-body
    v-if="hasContent"
    class="icon-text-tile-block"
    :bg-color="value.bgColor"
    :text-color="value.textColor"
    :text-align="value.textAlign">

    <titled-text-element
      :value="value"
      :no-bottom="hasElements"/>

    <page-block>

      <div
        class="icon-text-tile-block__elements row wrap">

        <icon-text-tile-element
          :value="element"
          :key="element.id"
          class="col-12 col-md-6 col-lg-4"
          v-for="element in value.elements"/>

      </div>

    </page-block>

  </page-block>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageBlockMixin from '@src/mixins/page-block-mixin';
  import TitledTextElement from '@src/components/element/titled-text-element';
  import IconTextTileElement from '@src/components/element/icon-text-tile-element';

  export default {
    name: 'icon-text-tile-block',
    mixins: [
      PageBlockMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      TitledTextElement,
      IconTextTileElement,
    },
  };

</script>

<style lang="scss">

  .icon-text-tile-block {
    color: inherit;

    &__elements {
      margin: -$spacer-sm;
    }
  }

</style>
